import * as React from "react";
import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import setupPrivateClient from "./apis/setupPrivateClient";
import App from "./App";

/* global document, Office, module, require, HTMLElement */

const container = document.getElementById("container") as HTMLElement;
const root = createRoot(container);

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <FluentProvider
      style={{ height: "100%", width: "100%" }}
      theme={webLightTheme}
    >
      <App />
    </FluentProvider>,
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./App", () => {
    const NextApp = require("./App").default;
    root?.render(NextApp);
  });
}

setupPrivateClient();
